(ns re-frame-notifier.components.modal
  (:require [re-frame-notifier.helpers :refer [action-and-close]]))

(defn modal-component
  [{:keys [component
           component-props
           hide-dismiss
           dismiss-button-class
           modal-container-class
           modal-component-container-class
           modal-underlay-class
           modal-aria-label
           close-btn-display]
    :or {component-props nil
         close-btn-display [:span "Close"]
         hide-dismiss false
         dismiss-button-class "notifier-dismiss-button"
         modal-container-class "notifier-modal-container"
         modal-component-container-class "notifier-modal-component-container"
         modal-underlay-class "notifier-underlay"
         modal-aria-label "Dialog"}}]
  [:div {:class modal-underlay-class}
   [:div {:class modal-container-class
          :role "dialog"
          :aria-modal "true"
          :aria-label modal-aria-label}
    (when-not hide-dismiss
      [:button
       {:class dismiss-button-class
        :on-click (action-and-close identity :modal)}
       close-btn-display])
    [:div {:class modal-component-container-class}
     [component (assoc component-props
                       :dismiss-fn (action-and-close identity :modal))]]]])
